import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { microAppInitialized } from '@mynexus/mfe-core';

@Component({
    selector: 'app-dmepos',
    templateUrl: './mnc-dmepos.component.html',
    styleUrls: ['./mnc-dmepos.component.scss'],
    standalone: false
})
export class MncDmePosComponent implements AfterViewInit {

  @Input() set url(value: string) {
    this.router.navigate([value]);
  }

  constructor(
    private ref: ElementRef,
    private router: Router) {
    // this is required to trigger the router for the micro app on initial load.
    this.router.initialNavigation();
  }

  ngAfterViewInit(): void {
    microAppInitialized(this.ref, this.router, 'DMEPOS');
  }
}
